import axios from 'axios'
import debounce from 'lodash/debounce'

import { SEARCH as ENDPOINT } from '../common/endpoints'

const MIN_SEARCH_LENGTH = 3

const makeAsyncSearch = () => {
	let _filterInputs = []
	let _filterNames = []
	let _filterValues = {}
	let _stringInput
	let _handleSearch
	let _axiosCancelToken
	let _searchParams = {}
	let _settings
	const Lang = window.motostorm?.lang
	var page = 2

	function _addFilter(inputs) {
		_filterInputs = []
		_filterInputs = _filterInputs.concat([...inputs])
		_filterNames = [...new Set(_filterInputs.map((input) => input.name))]
	}

	function _getFilterValue(name) {
		const inputs = _filterInputs.filter((input) => input.name === name)
		if (!inputs.length) {
			return undefined
		}

		const values = inputs
			.map((input) => {
				switch (input.type) {
					case 'checkbox':
					case 'radio':

						if (input.checked) {
							return input.value
						}
						return
					case 'number':
						return parseFloat(input.value)
					default:
						return input.value
				}
			})
			.filter((value) => value)

		switch (values.length) {
			case 0:
				return undefined
			case 1:
				return values[0]
			default:
				return values[0]
		}
	}

	function _getAllFilterValues(e) {
		const r = []

		_filterNames.forEach((name, key) => {
			if (e.target.name == [name]){
				if(e.target.checked){
					r[name] = e.target.value
				}
			} else {
				const value = _getFilterValue(name)
				if (value !== undefined) {
					r[name]=value
				}
			}
		})
		return r
	}

	function _handleInputFilter(e) {
		page = 2
		_filterValues = _getAllFilterValues(e)
		_handleSearch(e)
	}
	
	function _handlePagination(e){

		if ((e.target.scrollHeight + 1) >= (e.target.scrollTop + e.target.clientHeight) && (e.target.scrollHeight - 2) <= (e.target.scrollTop + e.target.clientHeight)) {
			// qui va inserita la funzione di caricamento
			_filterValues = _getAllFilterValues(e)
			_filterValues['pagination'] =  true
			_filterValues['page_no'] =  page
			_stringInput = document.getElementById('id-header-search')
			const productsWrapper = document.querySelector('.j-search-popup__cards-grid')

			_searchParams = {
				lang: Lang,
				q: _stringInput.value,
				..._filterValues,
			}

			axios.get(ENDPOINT, {
				params: _searchParams,
			})
			.then(resp => {
				productsWrapper.innerHTML += resp.data.html
				// if res last page is true remove event listener
				if (resp.data.results.lastpage === true){
					e.target.removeEventListener('scroll', _handlePagination)
				}
			})
			.catch(err => {
				// Handle Error Here
				console.error(err);
			})
			page++
		}
	}

	function init(settings) {
		if (!settings || !settings.searchInput) {
			return
		}

		_settings = settings

		const allFilterInputs = document.querySelectorAll('.j-filter-search__input')
		const closePopupMob = document.querySelector('.j-search-popup__close-button')

		if (closePopupMob) {

			closePopupMob.addEventListener('click', (e) => {
				document.body.classList.remove('has-searchpopup-open')
			})	
		}
		
		_addFilter(allFilterInputs)
		_stringInput = settings.searchInput

		_handleSearch = debounce(async (e) => {

			if (e.type == 'keyup' || e.type == 'paste') {
				_filterValues = {}
			}
			
			if (e.type == 'focus') {
				_filterValues['pagination'] = null
				_filterValues['page_no'] =  null
			}
			
			// close everything on esc key
			if (e.keyCode === 27) {
				_axiosCancelToken?.cancel('Operation canceled due to abort.')
				e.target.value = ''
				if (settings.callback && typeof settings.callback === 'function') {
					settings.callback(null, true)
				}
			}

			if (e.target.value.length < MIN_SEARCH_LENGTH) {
				// if not enough letters for a search, return and set loading screen
				if (settings.callback && typeof settings.callback === 'function') {
					settings.callback()
				}
				return
			}

			if (typeof _axiosCancelToken != typeof undefined) {
				_axiosCancelToken.cancel('Operation canceled due to new request.')
			}

			_axiosCancelToken = axios.CancelToken.source()

			_searchParams = {
				lang: Lang,
				q: _stringInput.value,
				..._filterValues,
			}

			const res = await axios.get(ENDPOINT, {
				cancelToken: _axiosCancelToken.token,
				params: _searchParams,
			})

			if (settings.callback && typeof settings.callback === 'function') {
				destroy()
				settings.callback(res)
			}
			
			const resultsWrapper = document.querySelector('.c-search-popup__products')
			if(resultsWrapper){
				resultsWrapper.addEventListener('scroll', _handlePagination)
			}
			
		}, 250)

		_stringInput.addEventListener('keyup', _handleSearch)
		_stringInput.addEventListener('paste', _handleSearch)
		
		if(_stringInput.value.length >= 3){
			_stringInput.addEventListener('focus', _handleSearch)
		}

		allFilterInputs.forEach(item => {
			item.addEventListener('change', _handleInputFilter)
		})		
	}
	
	function reinit() {
		init(_settings)
	}
	
	function focusOnSearch(){
		
	}

	function destroy() {
		_stringInput.removeEventListener('focus', _handleSearch)
		_stringInput.removeEventListener('keyup', _handleSearch)
		_stringInput.removeEventListener('paste', _handleSearch)

		_filterInputs.forEach((input) =>
			input.removeEventListener('change', _handleInputFilter)
		)
	}

	return {
		init,
		reinit,
		destroy,
		get searchParams() {
			return _searchParams
		},
	}
}

export default makeAsyncSearch
